import { ColorTokensProps, ElevationTokenProps } from "./../tokens/colors/ColorTokens";
import { IColors } from "./Colors";

export enum ThemeName {
	LIGHT = "theme-light",
	DARK = "theme-dark",
}

// TODO to be deprecated after full migration to bento
export type WeVideoTheme = {
	colors: IColors;
};

export type BentoTheme = {
	colors: ColorTokensProps;
	elevation: ElevationTokenProps;
};

export const ThemeAttribute = "data-theme";
